import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ItemsTable, { headerProps } from 'components/molecules/ItemsTable';
import { itemProps } from 'utilities/item';
import styles from './NestedItemsTable.module.css';

const propTypes = {
  className: PropTypes.string,
  emptyTableContent: PropTypes.node,
  expandedIds: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])).isRequired,
  headers: PropTypes.arrayOf(headerProps).isRequired,
  items: PropTypes.arrayOf(itemProps).isRequired,
  onSortChange: PropTypes.func,
  onSubSortChange: PropTypes.func,
  sort: PropTypes.shape({
    asc: PropTypes.bool,
    key: PropTypes.string,
  }),
  subHeaders: PropTypes.arrayOf(headerProps).isRequired,
  subItems: PropTypes.objectOf(PropTypes.arrayOf(itemProps)).isRequired,
  subSort: PropTypes.shape({
    asc: PropTypes.bool,
    key: PropTypes.string,
  }),
};

const defaultProps = {
  className: undefined,
  emptyTableContent: null,
  onSortChange: undefined,
  onSubSortChange: undefined,
  sort: undefined,
  subSort: undefined,
};

function NestedItemsTable({
  className,
  emptyTableContent,
  expandedIds,
  headers,
  items,
  onSortChange,
  onSubSortChange,
  sort,
  subHeaders,
  subItems,
  subSort,
}) {
  const renderSubItems = (id) => (
    <ItemsTable
      className={styles.subTable}
      headers={subHeaders}
      items={subItems[id] || []}
      sort={subSort}
      onSortChange={onSubSortChange}
    />
  );

  const subItemRow = (id) => ({
    element: renderSubItems(id),
    isSubItem: true,
    key: `sub-item-${id}`,
  });

  const expandedItems = useMemo(() => (
    items.reduce((arr, item) => {
      if (expandedIds.includes(item.id.value)) {
        return [...arr, item, subItemRow(item.id.value)];
      }
      return [...arr, item];
    }, [])
  ), [items, expandedIds, subItems]);

  if (items.length === 0) return emptyTableContent;

  return (
    <ItemsTable
      className={className}
      headers={headers}
      items={expandedItems}
      sort={sort}
      onSortChange={onSortChange}
    />
  );
}

NestedItemsTable.propTypes = propTypes;
NestedItemsTable.defaultProps = defaultProps;

export default NestedItemsTable;
